// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLogin: false,
    userInfo: null,
  };

  const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
      toggleAuth: (state, { payload }) => {
        state.isLogin = payload?.isLogin;
        state.userInfo = payload?.userInfo;
      }
    },
  });
  export const { toggleAuth} = authSlice.actions;

  export default authSlice.reducer;
  